import React from 'react'
import RoleTable from 'components/Tables/Role/RoleTabe'
// import ServiceTable from 'components/Tables/Service/ServiceTable'ssss
import ItemServicesTable from 'components/Tables/ItemServices/ItemServicesTable'
import Taxtable from 'components/Tables/TaxTables/Taxtable'

const ListTax = () => {
  return (
    <div><Taxtable /></div>
  )
}

export default ListTax